var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.row),function(columData,index){return _c("column-data",{key:((_vm.row ? _vm.row.id : '') + "-" + index),tag:"td",attrs:{"column":index,"data":columData,"headers":_vm.headers}})}))}
var staticRenderFns = []

export { render, staticRenderFns }